import React, {useState, useEffect} from 'react';
import {FormInput} from '../../../shared/form/form-control/FormInput.js';
import {withTranslation} from 'react-i18next';
import {Icon} from '../../../shared/elements/icon/Icon.js';
import {Accordion} from '../../../shared/elements/accordion/Accordion.js';
import {FormLabel} from '../../../shared/form/form-features/FormLabel.js';
import {getDateOfSameDayNextWeek, getDateToday} from './helper.js';
import {Col} from '../../../shared/grid/grid-features/Col.js';
import {FormDatePicker} from '../../../shared/form/form-control/FormDatePicker.js';
import styled from 'styled-components';
import {Row} from '../../../shared/grid/grid-features/Row.js';

function AddExtraWorkItem({t, path, onDelete, extraWorkItem, showErrors, setFieldValue, setFieldTouched}) {
    const [opened, setOpened] = useState(false);

    const togglePanel = () => {
        setOpened(!opened);
    };

    const [startDate, setStartDate] = useState(
        extraWorkItem.startDate ? new Date(extraWorkItem.startDate) : getDateToday(),
    );
    const [endDate, setEndDate] = useState(
        extraWorkItem.endDate ? new Date(extraWorkItem.endDate) : getDateOfSameDayNextWeek(startDate),
    );

    useEffect(() => {
        setFieldValue(`${path}.startDate`, startDate);
        setFieldValue(`${path}.endDate`, endDate);
        setFieldTouched(`${path.endDate}`, true);
    }, [startDate, endDate]);

    return (
        <Accordion
            link
            // We only want to show the errors are there when the field is collapsed
            showErrors={showErrors && !opened}
            color="primary"
            onClick={() => togglePanel()}
            accordionHeader={
                <>
                    {extraWorkItem.description || t('customer.OneExtraWorkItem')}
                    {!opened ? <Icon icon="KeyboardArrowDown" /> : <Icon icon="KeyboardArrowUp" />}
                </>
            }
            onDelete={() => onDelete()}
            isDisabled={extraWorkItem.isLinkedExtraWorkItem}
        >
            {opened && (
                <Accordion.Body>
                    <FormLabel>{t('customer.ExtraWorkItem.Description')}</FormLabel>
                    <FormInput name={`${path}.description`} placeholder={t('customer.ExtraWorkItem.Description')} />
                    <Wrapper>
                        <Col colsize="25">
                            <FormDatePicker
                                label={t('customer.StartDate')}
                                name={`${path}.startDate`}
                                selected={startDate}
                                onChange={(date) => {
                                    setStartDate(date);
                                    setFieldTouched(`${path}.startDate`, true);
                                    setFieldTouched(`${path}.endDate`, true); // setting both to touched since they are connected
                                }}
                                selectsStart
                                startDate={startDate}
                                endDate={endDate}
                                dateFormat="dd-MM-yyyy"
                                calendarStartDay={1}
                            />
                        </Col>
                        <Col colsize="25">
                            <FormDatePicker
                                label={t('customer.EndDate')}
                                name={`${path}.endDate`}
                                selected={endDate}
                                onChange={(date) => {
                                    setEndDate(date);
                                    setFieldTouched(`${path}.startDate`, true);
                                    setFieldTouched(`${path}.endDate`, true); // setting both to touched since they are connected
                                }}
                                selectsEnd
                                startDate={startDate}
                                endDate={endDate}
                                minDate={startDate}
                                dateFormat="dd-MM-yyyy"
                                calendarStartDay={1}
                            />
                        </Col>
                        <Col colsize="25">
                            <FormLabel>{t('customer.ExtraWorkItem.PricePerUnit')}</FormLabel>
                            <FormInput name={`${path}.pricePerUnit`} prefixIcon="euro" placeholder="0.00" />
                        </Col>
                        <Col colsize="25">
                            <FormLabel>{t('customer.ExtraWorkItem.Unit')} </FormLabel>
                            <FormInput
                                name={`${path}.unit`}
                                placeholder={t('customer.ExtraWorkItem.UnitExplanation')}
                            />
                        </Col>
                    </Wrapper>
                </Accordion.Body>
            )}
        </Accordion>
    );
}

const Wrapper = styled(Row)`
    align-items: baseline;
`;

export default withTranslation()(AddExtraWorkItem);
